import { Link } from "react-router-dom";
import PricingSection from "../components/PricingSection";
import PublicNav from "../components/PublicNav";
import { trackVisitorEvent, captureUtmFromUrl } from "../lib/visitorAnalytics";
import { useEffect } from "react";

export default function Pricing() {
  useEffect(() => {
    captureUtmFromUrl();
    trackVisitorEvent("pricing_viewed", { page: "pricing" });
  }, []);

  return (
    <main className="login-screen landing-screen pricing-page" data-testid="pricing-page">
      <div className="login-grid" />
      <PublicNav />
      <div className="pricing-page-body">
        <PricingSection onViewed={() => trackVisitorEvent("pricing_viewed", { page: "pricing_section" })} />
        <p className="text-button-wrap">
          <Link data-testid="pricing-back-landing" className="text-button" to="/">← Back to home</Link>
        </p>
      </div>
    </main>
  );
}
